<template>
  <v-progress-linear
    v-model="_value"
    :indeterminate="_indeterminate"
    color="#22d3ee"
  >
    <slot />
  </v-progress-linear>
</template>

<script setup lang="ts">

import {computed} from "vue";
import {ref, watch} from "vue";

interface Props {
  indeterminate?: boolean
  modelValue?: number,
}

const _props = withDefaults(defineProps<Props>(), {indeterminate: false, modelValue: undefined}
)

const _indeterminate = computed(() => {
  return _props.indeterminate ?? false
})

watch((_props), () => {
  _value.value = _props.modelValue
})

const _value = ref<number | undefined>(undefined)

</script>

<style scoped>

</style>
